<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon2-line-chart"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>

        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit.prevent="search">
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>CCTR:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'venCCTR'"
                    :name="'venCCTR'"
                    :select2-options="cctrOptions"
                    v-model="searchCCTR"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>IO:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'venIO'"
                    :name="'venIO'"
                    :select2-options="ioOptions"
                    v-model="searchIO"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>GL:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'venGL'"
                    :name="'venGL'"
                    :select2-options="glOptions"
                    v-model="searchGL"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>แผนก:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'venOrg'"
                    :name="'venOrg'"
                    :multiple="true"
                    :select2-options="orgOptions"
                    v-model="searchOrgCodes"
                  ></select2>
                </div>
              </div>
            </div>

            <!-- spec sheet 4: Vendor + ชื่อสินค้า เป็น "ช่องพิมพ์" · อยู่แถวเดียวกับช่วงวันที่ -->
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>Vendor:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchVendor"
                    placeholder="กรุณาระบุชื่อหรือรหัส Vendor (คั่น,(ลูกน้ำ)ได้)"
                    maxlength="200"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchProductName"
                    placeholder="กรุณาระบุรายการสินค้า (คั่น,(ลูกน้ำ)ได้)"
                    maxlength="200"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>วันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วว/ดด/ปปปป"
                      id="venDateFrom"
                      name="venDateFrom"
                      ref="venDateFrom"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>วันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วว/ดด/ปปปป"
                      id="venDateTo"
                      name="venDateTo"
                      ref="venDateTo"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-primary mr-2" :disabled="isLoading">
                  <i class="fa fa-search"></i> {{ isLoading ? "กำลังค้นหา..." : "ค้นหา" }}
                </button>
                <button type="button" class="btn btn-secondary mr-2" @click="resetForm">
                  <i class="fa fa-undo"></i> ล้างค่าทั้งหมด
                </button>
                <button type="button" class="btn btn-success float-right" @click="exportExcel" :disabled="isExporting">
                  <i class="fa fa-file-excel"></i>
                  {{ isExporting ? "กำลัง Export..." : "Export" }}
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <hr />

          <!-- begin: ผลลัพธ์ -->
          <div v-if="!hasSearched" class="alert alert-secondary">
            กดปุ่ม <strong>"ค้นหา"</strong> เพื่อแสดงข้อมูล
          </div>

          <div v-else-if="rows.length === 0" class="alert alert-warning">
            ไม่พบข้อมูลตามเงื่อนไขที่ระบุ
          </div>

          <template v-else>
            <div class="table-responsive vendor-usage-scroll">
              <table class="table table-sm vendor-usage-table">
                <!--
                  ISS-37 (8 ต.ค. 2026 · QA BUG-05) สัดส่วนคอลัมน์ตามความกว้างในสเปก sheet 4
                  A 38.55 · B 41.78 · C 14.00 · D 17.33 · E 24.89 (+ F 18.00 ของ ISS-41 ซึ่งไม่มีในสเปก)
                  แปลงเป็น % ของผลรวม — เดิมไม่มี colgroup เลย เบราว์เซอร์จัดเองตามเนื้อหา
                  ISS-97 (ผู้ใช้สั่ง 23 ต.ค. 2026): รวม 16% / เลขที่ใบงาน 12% -> 11% เท่าราคาต่อหน่วย · ส่วนที่เหลือให้ Vendor 25% -> 31%
                -->
                <colgroup>
                  <col style="width: 31%" />
                  <col style="width: 27%" />
                  <col style="width: 9%" />
                  <col style="width: 11%" />
                  <col style="width: 11%" />
                  <col style="width: 11%" />
                </colgroup>
                <thead>
                  <tr>
                    <!-- ISS-88 (ผู้ใช้เคาะ 22 ต.ค. 2026): sort ได้เฉพาะคอลัมน์ Vendor · คงโครงสร้างกลุ่ม (สลับทั้งบล็อกของ Vendor) -->
                    <th class="text-center sortable-th" @click="toggleVendorSort" title="เรียงตาม Vendor">
                      {{ headers[0] || "Vendor" }}
                      <span class="sort-icon"><span :class="{ active: vendorSortDir === 'asc' }">&#8593;</span><span :class="{ active: vendorSortDir === 'desc' }">&#8595;</span></span>
                    </th>
                    <th class="text-center">{{ headers[1] || "รายการสินค้า" }}</th>
                    <th class="text-center">{{ headers[2] || "จำนวน" }}</th>
                    <th class="text-center">{{ headers[3] || "ราคาต่อหน่วย" }}</th>
                    <th class="text-center">{{ headers[4] || "รวม" }}</th>
                    <th class="text-center">{{ headers[5] || "เลขที่ใบงาน" }}</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- ISS-76: vendor-start = เส้นคั่น Vendor (หนาสุด) · block-start = เส้นคั่นสินค้า (หนารอง) -->
                  <tr v-for="(r, i) in displayRows" :key="'r' + i" :class="{ 'block-start': r.showItemName, 'vendor-start': r.showVendor }">
                    <td>{{ r.showVendor ? r.vendor : "" }}</td>
                    <td class="pre-line">{{ r.showItemName ? r.itemName : "" }}</td>
                    <!-- ISS-25 + ISS-28: ค่าลบแสดงเป็น -x สีแดง ให้ตรงกับไฟล์ Excel
                         สีผูกกับ "ทั้งแถว" — แถวรายการติดลบ ตัวเลขทุกช่องต้องแดง
                         รวมถึงราคาต่อหน่วยที่เป็นค่าบวก -->
                    <td class="text-right" :class="{ 'text-danger': isNegativeRow(r) }">{{ fmtQuantity(r.quantity) }}</td>
                    <td class="text-right" :class="{ 'text-danger': isNegativeRow(r) }">{{ r.showUnitPrice ? fmtAccounting(r.unitPrice) : "" }}</td>
                    <td class="text-right" :class="{ 'text-danger': isNegativeRow(r) }">{{ fmtAccounting(r.amount) }}</td>
                    <!-- ISS-41 (QA CR-ADD-01) 1 บรรทัด = 1 เอกสาร · เปิดแถบใหม่ แบบเดียวกับ BudgetPlanDetail.vue -->
                    <td class="text-center">
                      <!-- ISS-60: ใบเบิก ตามด้วยใบคืนที่มาหัก · แต่ละเลขเป็นลิงก์ของตัวเอง
                           ISS-75 (UAT 22 ต.ค. 2026): ลูกน้ำแล้วขึ้นบรรทัดใหม่ 1 ใบต่อบรรทัด -->
                      <template v-if="r.jobs && r.jobs.length">
                        <span v-for="(j, k) in r.jobs" :key="'j' + i + '-' + j.jobId"><a :href="'/BudgetPlan/Job/View/' + j.jobId" target="_blank">{{ j.jobNumber }}</a><template v-if="k < r.jobs.length - 1">,<br /></template></span>
                      </template>
                      <a v-else-if="r.jobNumber" :href="'/BudgetPlan/Job/View/' + r.jobId" target="_blank">{{ r.jobNumber }}</a>
                    </td>
                  </tr>
                  <tr class="grand-total-row">
                    <!-- ISS-64: "Grand Total" อยู่คอลัมน์รายการสินค้า ชิดซ้ายแนวเดียวกับข้อมูล (สเปก B38) -->
                    <td></td>
                    <td><strong>{{ grandTotalLabel }}</strong></td>
                    <td class="text-right" :class="{ 'text-danger': isNegative(grandTotalQuantity) }"><strong>{{ fmtQuantity(grandTotalQuantity) }}</strong></td>
                    <td></td>
                    <td class="text-right" :class="{ 'text-danger': isNegative(grandTotalAmount) }"><strong>{{ fmtAccounting(grandTotalAmount) }}</strong></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <!-- end: ผลลัพธ์ -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import select2 from "../../Shared/Select2";

require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function () {
    return {
      searchCCTR: null,
      searchIO: null,
      searchGL: null,
      searchOrgCodes: [],

      // spec sheet 4: ช่องพิมพ์ — คั่นหลายค่าด้วย ',' (= OR ฝั่ง API)
      searchVendor: "",
      searchProductName: "",

      // เก็บเป็น moment (หรือ null) — bootstrap-datepicker ไม่ bind กับ v-model
      searchDateFrom: moment().startOf("year"),
      searchDateTo: moment(),

      cctrOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      ioOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      glOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      orgOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },

      headers: [],
      rows: [],
      // ISS-88: ลำดับจาก server = Vendor น้อย → มาก ("อื่นๆ" ท้ายสุด) จึงถือเป็น "asc" ตั้งต้น
      vendorSortDir: "asc",
      grandTotalLabel: "Grand Total",
      grandTotalQuantity: null,
      grandTotalAmount: 0,

      hasSearched: false,
      isLoading: false,
      isExporting: false,

      // กัน race condition ของ cascading dropdown (Design §4 SQ-02)
      dropdownSeq: 0,
    };
  },
  computed: {
    /**
     * ISS-88: แถวที่แสดงตามทิศ sort ของคอลัมน์ Vendor
     *   แบ่งเป็นบล็อกต่อ Vendor (เริ่มที่แถว showVendor) แล้วสลับทั้งบล็อก — โครงสร้างภายใน Vendor
     *   (ชื่อสินค้า/กลุ่มราคา/ใบคืน/เส้นคั่น) คงเดิม · "อื่นๆ" อยู่ท้ายเสมอ · Grand Total อยู่นอก rows
     *   Excel ไม่ตาม (ใช้ลำดับเริ่มต้น · Q88-3)
     */
    displayRows: function () {
      if (this.vendorSortDir !== "desc") return this.rows;
      var blocks = [];
      this.rows.forEach(function (r, i) {
        if (i === 0 || r.showVendor) blocks.push([]);
        blocks[blocks.length - 1].push(r);
      });
      var isOther = function (b) { return (b[0].vendor || "").indexOf("อื่นๆ") === 0; };
      var normal = blocks.filter(function (b) { return !isOther(b); }).reverse();
      var others = blocks.filter(isOther);
      return [].concat.apply([], normal.concat(others));
    },
  },
  watch: {
    // cascading: เปลี่ยน filter ใดก็โหลดตัวเลือกของช่องที่เหลือใหม่ (Q-C3)
    searchCCTR: function () {
      this.clearScopedFilters();
      this.loadDropdowns();
    },
    searchIO: function () {
      this.loadDropdowns();
    },
    searchGL: function () {
      this.loadDropdowns();
    },
    searchOrgCodes: function () {
      this.loadDropdowns();
    },
    searchDateFrom: function () {
      this.loadDropdowns();
    },
    searchDateTo: function () {
      this.loadDropdowns();
    },
  },
  mounted: function () {
    this.initDatepickers();
    this.loadDropdowns();
  },
  methods: {
    toggleVendorSort: function () {
      this.vendorSortDir = this.vendorSortDir === "asc" ? "desc" : "asc";
    },
    /**
     * ปฏิทิน — ใช้ bootstrap-datepicker แบบเดียวกับหน้าอื่นในระบบ
     * (เทียบแบบจาก Components/PM/SearchCheckIn.vue) · รูปแบบ dd/mm/yyyy
     * jQuery ไม่ bind กับ Vue model จึงต้องรับค่าผ่าน event changeDate เอง
     */
    initDatepickers: function () {
      var self = this;
      var arrows = KTUtil.isRTL()
        ? { leftArrow: '<i class="la la-angle-right"></i>', rightArrow: '<i class="la la-angle-left"></i>' }
        : { leftArrow: '<i class="la la-angle-left"></i>', rightArrow: '<i class="la la-angle-right"></i>' };

      var dpOptions = {
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows,
      };

      $(self.$refs.venDateFrom).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchDateFrom = e.date ? moment(e.date) : null;
      });
      $(self.$refs.venDateTo).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchDateTo = e.date ? moment(e.date) : null;
      });

      self.syncDatepickerInputs();
    },

    /** เขียนค่าใน data ลงช่องปฏิทิน (ใช้ตอน init และตอนล้างค่า) */
    syncDatepickerInputs: function () {
      var self = this;
      $(self.$refs.venDateFrom).datepicker(
        "update", self.searchDateFrom ? self.searchDateFrom.format("DD/MM/YYYY") : "");
      $(self.$refs.venDateTo).datepicker(
        "update", self.searchDateTo ? self.searchDateTo.format("DD/MM/YYYY") : "");
    },

    /**
     * 🔴 Shared/Select2.vue ผูก select2 ครั้งเดียวตอน mounted และ **ไม่มี watcher**
     * บน prop select2-options → ถ้าเราแค่เปลี่ยนค่าใน options ตัวเลือกจะไม่ขึ้นเลย
     * จึงต้องสั่ง re-init เอง (วิธีเดียวกับ BudgetPlanJobList.refreshSelect2Dropdown)
     */
    refreshSelect2: function (elId, options) {
      var $select = $("#" + elId);
      if (!$select.length) return;

      var current = $select.val();

      if ($select.data("select2")) $select.select2("destroy");
      $select.empty();
      $select.append('<option value=""></option>');
      (options.data || []).forEach(function (item) {
        $select.append($("<option></option>").attr("value", item.id).text(item.text));
      });

      $select.select2({
        placeholder: options.placeholder,
        allowClear: options.allowClear,
      });

      // คงค่าที่ผู้ใช้เลือกไว้ ถ้ายังอยู่ในตัวเลือกชุดใหม่
      var stillThere = current && (options.data || []).some(function (item) {
        return Array.isArray(current)
          ? current.indexOf(String(item.id)) >= 0
          : String(item.id) === String(current);
      });
      $select.val(stillThere ? current : null).trigger("change.select2");
    },

    clearScopedFilters: function () {
      this.searchIO = null;
      this.searchGL = null;
      this.searchOrgCodes = [];
      $("#venIO").val(null).trigger("change");
      $("#venGL").val(null).trigger("change");
      $("#venOrg").val(null).trigger("change");
    },

    loadDropdowns: function () {
      var self = this;
      var seq = ++self.dropdownSeq;

      axios
        .get("/Api/BudgetPlan/Report/Vendor/Dropdown", { params: self.buildParams() })
        .then(function (response) {
          // ทิ้ง response ที่ล้าสมัย (ผู้ใช้เปลี่ยน filter เร็วกว่า response กลับมา)
          if (seq !== self.dropdownSeq) return;
          if (!response.data || !response.data.success) {
            // ไม่เด้ง modal ขัดจังหวะผู้ใช้ แต่ต้องเห็นใน console
            // (ฝั่ง API log ไว้แล้วผ่าน BudgetActivityLog.LogError)
            console.warn("Failed to load vendor usage report dropdowns:",
              (response.data && response.data.message) || "unknown error");
            return;
          }

          var d = response.data.data;

          // แก้ค่าในที่เดิม แล้วสั่ง select2 สร้างตัวเลือกใหม่
          // (การสร้าง object ใหม่ด้วย Object.assign ไม่มีผล เพราะ Select2.vue ไม่ watch prop นี้)
          self.cctrOptions.data = (d.cctrs || []).map(self.toOption);
          self.ioOptions.data = (d.ios || []).map(self.toOption);
          self.glOptions.data = (d.gls || []).map(self.toOption);
          self.orgOptions.data = (d.orgs || []).map(self.toOption);

          self.refreshSelect2("venCCTR", self.cctrOptions);
          self.refreshSelect2("venIO", self.ioOptions);
          self.refreshSelect2("venGL", self.glOptions);
          self.refreshSelect2("venOrg", self.orgOptions);
        })
        .catch(function (error) {
          console.error("Failed to load vendor usage report dropdowns:", error);
        });
    },

    toOption: function (item) {
      return { id: item.code, text: item.text };
    },

    buildParams: function () {
      var params = {};
      if (this.searchCCTR) params.cctrCode = this.searchCCTR;
      if (this.searchIO) params.ioCode = this.searchIO;
      if (this.searchGL) params.glCode = this.searchGL;
      if (this.searchOrgCodes && this.searchOrgCodes.length > 0) {
        params.orgCodes = this.searchOrgCodes.join(",");
      }
      if (this.searchVendor && this.searchVendor.trim()) {
        params.vendorSearch = this.searchVendor.trim();
      }
      if (this.searchProductName && this.searchProductName.trim()) {
        params.productName = this.searchProductName.trim();
      }
      // API รับได้ทั้ง yyyy-MM-dd และ dd/MM/yyyy (ParseReportDate)
      if (this.searchDateFrom) params.dateFrom = this.searchDateFrom.format("DD/MM/YYYY");
      if (this.searchDateTo) params.dateTo = this.searchDateTo.format("DD/MM/YYYY");
      return params;
    },

    validate: function () {
      // CCTR ไม่บังคับแล้ว — spec sheet 4 ไม่ได้ระบุว่าเป็น required (ISS-06)
      // ISS-98 (ผู้ใช้สั่ง 23 ต.ค. 2026): ข้อความ/ลำดับเดียวกับ BudgetDateRangeRule.ValidateVendorReport ฝั่ง API
      //   ไม่กรอกทั้ง 2 ช่อง = ค้นหาได้ทุกปีเหมือนเดิม
      var from = this.searchDateFrom;
      var to = this.searchDateTo;
      var message = null;
      if (!!from !== !!to) {
        message = "โปรดระบุช่วงวันที่(เริ่มต้น)และวันที่(สิ้นสุด)ของปีงบประมาณที่ต้องการค้นหา";
      } else if (from && from.year() !== to.year()) {
        message = "โปรดระบุช่วงวันที่ภายในปีงบประมาณใดงบประมาณหนึ่งเท่านั้น";
      } else if (from && from.isAfter(to, "day")) {
        message = "วันที่(เริ่มต้น) ต้องไม่มากกว่าวันที่(สิ้นสุด)";
      }
      if (message) {
        Swal.fire("ไม่สามารถทำรายการได้", message, "warning");
        return false;
      }
      return true;
    },

    search: function () {
      var self = this;
      if (!self.validate()) return;

      self.isLoading = true;
      axios
        .get("/Api/BudgetPlan/Report/Vendor", { params: self.buildParams() })
        .then(function (response) {
          if (!response.data || !response.data.success) {
            Swal.fire("เกิดข้อผิดพลาด", (response.data && response.data.message) || "ไม่สามารถดึงข้อมูลได้", "error");
            return;
          }
          var d = response.data.data;
          self.headers = d.headers || [];
          self.rows = d.rows || [];
          self.vendorSortDir = "asc";
          self.grandTotalLabel = d.grandTotalLabel || "Grand Total";
          self.grandTotalQuantity = d.grandTotalQuantity;
          self.grandTotalAmount = d.grandTotalAmount || 0;
          self.hasSearched = true;
        })
        .catch(function (error) {
          console.error("Failed to load vendor usage report:", error);
          var message =
            (error.response && error.response.data && error.response.data.message) ||
            "ไม่สามารถดึงข้อมูลรายงานได้";
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
        })
        .finally(function () {
          self.isLoading = false;
        });
    },

    resetForm: function () {
      this.searchCCTR = null;
      $("#venCCTR").val(null).trigger("change");
      this.clearScopedFilters();

      this.searchVendor = "";
      this.searchProductName = "";

      this.searchDateFrom = moment().startOf("year");
      this.searchDateTo = moment();
      this.syncDatepickerInputs();

      this.headers = [];
      this.rows = [];
      this.grandTotalQuantity = null;
      this.grandTotalAmount = 0;
      this.hasSearched = false;

      this.loadDropdowns();
    },

    exportExcel: function () {
      var self = this;
      if (!self.validate()) return;

      self.isExporting = true;

      var params = new URLSearchParams();
      var p = self.buildParams();
      Object.keys(p).forEach(function (k) {
        params.append(k, p[k]);
      });

      axios
        .get("/Api/BudgetPlan/ExportVendorUsage?" + params.toString(), {
          headers: { Authorization: "Bearer " + self.$root.user.access_token },
          responseType: "blob",
        })
        .then(function (response) {
          var filename = "VendorUsage_" + self.searchCCTR + ".xlsx";
          var contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
              filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
          }

          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);

          Swal.fire("สำเร็จ", "Export รายงานตาม Vendor เรียบร้อยแล้ว", "success");
        })
        .catch(function (error) {
          console.error("Error exporting vendor usage report:", error);
          Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถ Export ข้อมูลได้", "error");
        })
        .finally(function () {
          self.isExporting = false;
        });
    },

    // ---------- formatters (ให้ตรงกับ number format ของไฟล์ Excel) ----------
    // ISS-25 (1 ต.ค. 2026): ค่าลบใช้เครื่องหมาย "-" ไม่ใช่วงเล็บ ให้ตรงกับ
    // number format ของไฟล์ Excel ที่เปลี่ยนไปตั้งแต่ ISS-18d — สีแดงทำที่ markup
    fmtAccounting: function (value) {
      if (value === null || value === undefined || value === "") return "";
      var n = Number(value);
      if (isNaN(n)) return "";
      if (n === 0) return "-";
      var text = Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return n < 0 ? "-" + text : text;
    },

    // "จำนวน" ไม่บังคับทศนิยม — เอกสารที่ไม่ระบุจำนวนต้องเว้นว่าง (ไม่ใช่ 0)
    fmtQuantity: function (value) {
      if (value === null || value === undefined || value === "") return "";
      var n = Number(value);
      if (isNaN(n)) return "";
      if (n === 0) return "-";
      var text = Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return n < 0 ? "-" + text : text;
    },

    // true = ค่านี้ติดลบ (ISS-25)
    isNegative: function (value) {
      if (value === null || value === undefined || value === "") return false;
      var n = Number(value);
      return !isNaN(n) && n < 0;
    },

    // ISS-28: แถวรายการติดลบ -> ตัวเลขทั้งแถวเป็นสีแดง
    // ไม่ใช่เฉพาะช่องที่ค่าติดลบ เพราะราคาต่อหน่วยเป็นบวกแต่อยู่ในรายการคืนเงินเดียวกัน
    isNegativeRow: function (r) {
      if (!r) return false;
      return this.isNegative(r.quantity) || this.isNegative(r.amount);
    },
  },
};

// yyyy-MM-dd ตาม local time (ห้ามใช้ toISOString เพราะจะเลื่อนวันตาม timezone)
</script>

<style scoped>
.vendor-usage-scroll {
  max-height: 65vh;
  overflow: auto;
}

.vendor-usage-table {
  font-size: 13px;
  /* ISS-37: ให้ความกว้างตาม colgroup จริง ไม่ยืดตามข้อความยาว (ข้อความยาวตัดขึ้นบรรทัดใหม่แทน) */
  table-layout: fixed;
}

.vendor-usage-table td {
  word-wrap: break-word;
}

/* ISS-88: หัวคอลัมน์ Vendor กด sort ได้ — ลูกศรแบบหน้ารายการใบงาน (ตัวที่ใช้อยู่สว่าง) */
.vendor-usage-table thead th.sortable-th {
  cursor: pointer;
  user-select: none;
  position: sticky;
}

.vendor-usage-table thead th .sort-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.85rem;
  letter-spacing: -2px;
  color: rgba(255, 255, 255, 0.4);
}

.vendor-usage-table thead th .sort-icon .active {
  color: #ffffff;
}

.vendor-usage-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #44546a;
  color: #ffffff;
  vertical-align: middle;
  font-weight: 600;
  border: 1px solid #b6bfcc;
  /* ISS-44 (8 ต.ค. 2026) หัวตารางต้องสูงเท่าแถวข้อมูล
     Metronic ใส่ padding ให้ th 15px ขณะที่ td ได้ 0.3rem (4.5px) จาก table-sm -> หัวสูง 51px แถว 30px */
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  /* ISS-86 (22 ต.ค. 2026): สูงเท่าหัวตาราง Excel 23.45pt ≈ 31px (เดิม ≈ 30px จาก padding) */
  height: 31px;
}

/* ISS-32 (7 ต.ค. · QA BUG-04) เส้นตารางต้องเห็นได้ครบทุกด้าน
   เดิม td เป็น border:none แล้วตีเส้นบนเฉพาะแถวหัวกลุ่ม
   ทำให้แถวในกลุ่มเดียวกันไม่มีเส้นคั่นเลย และ Metronic ใส่ #ebedf2 (เกือบขาว) ทับให้ */
/* ISS-76 (UAT 22 ต.ค. 2026 · ตัวอย่างไฟล์ UAT แถว 16–24): เส้นแนวนอนเฉพาะจุดคั่น
     คั่น Vendor = เส้นหนาสุด 2px #8d99ab · คั่นสินค้า = เส้นหนารอง 1px #b6bfcc (ไม่ตีในคอลัมน์ Vendor)
     สินค้าเดียวกันหลายใบงาน = ไม่มีเส้น · คอลัมน์ Vendor ไม่ merge แค่ไม่มีเส้นแนวนอนภายใน Vendor
     เส้นแนวตั้งคงไว้ทุกช่อง (ISS-32) */
.vendor-usage-table td {
  vertical-align: top;
  border: none;
  border-left: 1px solid #b6bfcc;
  border-right: 1px solid #b6bfcc;
}

/* ISS-78 (22 ต.ค. 2026): แถวแรกของ Vendor เป็น block-start ด้วย — เดิม selector นี้มี :not(:first-child)
     ทำให้ specificity สูงกว่ากฎ vendor-start -> คอลัมน์ 2–6 ได้ 1px แทน 2px (เส้นคั่น Vendor บางเท่าเส้นคั่นสินค้า)
     จึงยกเว้นแถว vendor-start ออกจากกฎนี้ */
.vendor-usage-table tbody tr.block-start:not(.vendor-start) td:not(:first-child) {
  border-top: 1px solid #b6bfcc;
}

.vendor-usage-table tbody tr.vendor-start td {
  border-top: 2px solid #8d99ab;
}

.vendor-usage-table tbody td:first-child {
  border-left: 1px solid #b6bfcc;
}

.vendor-usage-table tbody td:last-child {
  border-right: 1px solid #b6bfcc;
}

/* ISS-63 (21 ต.ค. 2026): กรอบรอบแถว Grand Total หนาเท่ากันทั้ง 4 ด้าน */
.vendor-usage-table .grand-total-row td {
  border-top: 2px solid #44546a;
  border-bottom: 2px solid #44546a;
  background-color: #d9e1f2;
}

.vendor-usage-table tbody .grand-total-row td:first-child {
  border-left: 2px solid #44546a;
}

.vendor-usage-table tbody .grand-total-row td:last-child {
  border-right: 2px solid #44546a;
}

/* ISS-66 (21 ต.ค. 2026): ไม่มีเส้นคั่นระหว่างช่อง Vendor (ว่าง) กับช่อง "Grand Total" */
.vendor-usage-table tbody .grand-total-row td:nth-child(1) {
  border-right: none;
}

.vendor-usage-table tbody .grand-total-row td:nth-child(2) {
  border-left: none;
}

.pre-line {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/VendorUsageReport.vue